import { Injectable } from '@angular/core';

import { AuthService } from '../common/auth.service';
import { ActionCableService } from '../common/action-cable.service';
import { DataStoreService } from '../common/data-store.service';
import { NotyService } from '../common/noty.service';

@Injectable({
  providedIn: 'root',
})
export class DocumentChannelService {
  /**
   * All subscriptions
   * @type {any}
   */
  subscriptions: any = {};

  /**
   * Channel Name
   * @type {string}
   */
  channelName: string = 'DocumentChannel';

  verifyingUserLoggedIn: boolean = false;

  constructor(private actionCableService: ActionCableService, private authService: AuthService) {}

  connectForDocumentEdit(identifier: string, reset: boolean = false) {
    let scope: DocumentChannelService = this;
    this.actionCableService.cable().then((cable) => {
      console.log('Subscribing to Document Edit lock', cable);
      if (this.subscriptions.documentEditNotification && reset) {
        this.subscriptions.documentEditNotification.unsubscribe();
        this.subscriptions.documentEditNotification = null;
      }
      if (!this.subscriptions.documentEditNotification)
        this.subscriptions.documentEditNotification = cable.subscriptions.create(
          {
            channel: this.channelName,
            identifier: `document_edit_${identifier}`,
            action: 'permission_to_edit',
          },
          {
            connected: () => {
              console.log(`Subscribed for document edit lock ${identifier}`);
            },
            received: (data: any) => {
              console.log('Received');
              console.log(data);
            },
            rejected: () => {
              console.log('document edit lock rejected');
            },
          }
        );
    });
  }

  verifyUserLoggedIn() {
    if (this.verifyingUserLoggedIn) return;
    this.verifyingUserLoggedIn = true;
    this.authService
      .getCurrentUserGroups(true)
      .then((response_json) => {
        if (!response_json.current_user_id) console.log('User not logged in');
        this.verifyingUserLoggedIn = false;
      })
      .catch((err) => {
        console.error(err);
        console.log('User not logged in');
        this.verifyingUserLoggedIn = false;
      });
  }
}
